import { render } from "./AlertsRss.vue?vue&type=template&id=7209ea1a"
import script from "./AlertsRss.vue?vue&type=script&lang=js"
export * from "./AlertsRss.vue?vue&type=script&lang=js"

import "./AlertsRss.vue?vue&type=style&index=0&id=7209ea1a&lang=css"

import exportComponent from "D:\\dev\\mdm-crtwww-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__